import { ApiUrls } from '@api/apiUrls';
import { fetchApi, FetchApiResponse } from 'api/fetchApi';
import {
  IApiCommissionAccountInfoResponse,
  IApiCreateMamMasterAccountRequest,
  IApiMamMasterAccount,
  IApiMamMasterAccountDetails,
  IApiMamSettingsResponse,
  IApiUpdateMamMasterAccountRequest,
  IApiUserTradingAccountType,
} from 'api/interfaces/data-contracts';

export const apiMamManagerService = {
  getMamLinkCreationSettings: async (): Promise<FetchApiResponse<IApiMamSettingsResponse>> => {
    return await fetchApi.get<IApiMamSettingsResponse>(ApiUrls.mamManager.getMamLinkCreationSettings);
  },
  getCommissionAccountInfo: async (): Promise<FetchApiResponse<IApiCommissionAccountInfoResponse>> => {
    return await fetchApi.get<IApiCommissionAccountInfoResponse>(ApiUrls.mamManager.getCommissionAccountInfo);
  },
  getMamAccountTypes: async (): Promise<FetchApiResponse<IApiUserTradingAccountType[]>> => {
    return await fetchApi.get<IApiUserTradingAccountType[]>(ApiUrls.mamManager.getMamAccountTypes);
  },
  getMamAccounts: async (): Promise<FetchApiResponse<IApiMamMasterAccount[]>> => {
    return await fetchApi.get<IApiMamMasterAccount[]>(ApiUrls.mamManager.getMamAccounts);
  },
  getMamLinkDetails: async (mamMasterAccountId: number): Promise<FetchApiResponse<IApiMamMasterAccountDetails>> => {
    return await fetchApi.get<IApiMamMasterAccountDetails>(ApiUrls.mamManager.getMamLinkDetails, {
      params: { id: mamMasterAccountId },
    });
  },
  createMamLink: async (data: IApiCreateMamMasterAccountRequest): Promise<FetchApiResponse<null>> => {
    return await fetchApi.post<null>(ApiUrls.mamManager.createMamLink, data);
  },
  updateMamLink: async (id: number, data: IApiUpdateMamMasterAccountRequest): Promise<FetchApiResponse<null>> => {
    return await fetchApi.post<null>(ApiUrls.mamManager.updateMamLink, data, { params: { id } });
  },
  approveMamLink: async (id: number): Promise<FetchApiResponse<null>> => {
    return await fetchApi.post<null>(ApiUrls.mamManager.approveMamLink, {}, { params: { id } });
  },
};
